import { render, staticRenderFns } from "./FAQComponent.vue?vue&type=template&id=12374493&scoped=true"
import script from "./FAQComponent.vue?vue&type=script&lang=js"
export * from "./FAQComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12374493",
  null
  
)

export default component.exports